<template>
  <p class="pagination">
    <a
      class="btn btn_grey btn_prev"
      secondary
      v-show="selectValue !== 1"
      @click.prevent="changePage(selectValue - 1)"
    >Předchozí</a>

    <app-select
      selectId="pagination"
      name="pagination"
      :value="selectValue"
      :options="paginationOptions"
      @change="changePage($event)"
    />

    <a
      class="btn btn_grey btn_next"
      secondary
      v-show="selectValue !== paginationOptions.length"
      @click.prevent="changePage(selectValue + 1)"
    >Další</a>
  </p>
</template>

<script>
import { min } from 'ramda'

export default {
  props: {
    itemsPerPage: {
      type: Number,
      required: true
    },
    totalCount: {
      type: Number,
      required: true
    },
    page: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      selectValue: this.page
    }
  },
  computed: {
    paginationOptions() {
      const options = []
      let page = 1
      let to = 0

      while (to < this.totalCount) {
        const from = (page - 1) * this.itemsPerPage + 1
        to = min(page * this.itemsPerPage, this.totalCount)

        options.push({
          value: page,
          name: `${from}-${to}`
        })

        page++
      }

      return options
    }
  },
  methods: {
    changePage(page) {
      if (page < 1 || page > this.paginationOptions.length) {
        return
      }
      this.selectValue = parseInt(page, 10)
      this.$emit('pageChanged', page)
    }
  },
  watch: {
    page(v) {
      this.selectValue = v
    }
  }
}
</script>
